import { Component, EventEmitter, OnInit } from '@angular/core';
import { EmojiData } from 'src/app/shared/models/emoji.model';

@Component({
  selector: 'app-emoji-input-list',
  templateUrl: './emoji-input-list.component.html',
  styleUrls: ['./emoji-input-list.component.scss']
})
export class EmojiInputListComponent implements OnInit {
  public categoryKeys: string[] = [];

  public emojiMap = new Map<string, EmojiData[]>();
  public lastSelected: EmojiData[] = [];

  public onSelect = new EventEmitter<EmojiData>();

  constructor() {}

  ngOnInit(): void {}

  public initData(emojiMap: Map<string, EmojiData[]>, lastSelected: EmojiData[]): void {
    this.emojiMap = emojiMap;
    this.categoryKeys = Array.from(emojiMap.keys());
    this.lastSelected = lastSelected;
  }

  public select(event: MouseEvent, data: EmojiData): void {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();

    this.onSelect.emit(data);
  }
}
